.DropdownWithLabel-wrapper {
  [class*="contextMenuWrapper"] {
    z-index: 1;
  }
  
  .DropdownWithLabel-button {
    display: flex;
    align-items: center;
    column-gap: 8px;
    padding: 2px 0;
    
    .DropdownWithLabel-label {
      font-size: 14px;
      font-weight: 400;
      color: var(--color_neutral_500);
    }

    .DropdownWithLabel-selected {
      font-size: 14px;
      font-weight: 700;
      color: var(--color_neutral_800);
    }
  }
}
